import {Component, OnInit, ViewChild} from '@angular/core';
import {PhoneTypeEnum} from '../../enums/phone';
import {NgForm} from '@angular/forms';
import {IPhoneNumber} from '../../interfaces/phone-number/phone-number.interface';
import {HelperValidationField} from '../../class/helper/helper-validation-field.class';

@Component({
  selector: 'app-clinic-register-contact',
  templateUrl: './clinic-register-contact.component.html',
  styleUrls: ['./clinic-register-contact.component.scss']
})
export class ClinicRegisterContactComponent implements OnInit {

  phoneTypeEnum = PhoneTypeEnum;
  helperValidationField: HelperValidationField;
  @ViewChild('form') form: NgForm;
  @ViewChild('formEmail') formEmail: NgForm;
  phone: IPhoneNumber;
  clinicEmail: string;
  constructor() { }

  ngOnInit(): void {
    this.helperValidationField = new HelperValidationField();
    this.phone = {
      ext: null,
      type: null,
      areaCode: null,
      phoneNumber: null
    };
  }

  validate(): void {
    this.form.control.markAllAsTouched();
    this.formEmail.control.markAllAsTouched();
  }

  getValue(): { phone: IPhoneNumber, email: string } {
    if (!(this.form.valid && this.formEmail.valid)) return;
    if (!this.phone.ext) {
      this.phone.ext = '';
    }
    return {
      phone: this.phone,
      email: this.clinicEmail
    };
  }
}
